<template>
	<div>
		<Top :showmoreclass="showmoreclass" flag="1"></Top>
		<div class="home">
			<div v-for="(item, index) in wddatalist" :key="index">
				<div v-if="item.type == 2">
					<!-- 轮播图 -->
					<el-carousel :interval="5000" arrow="always">
						<el-carousel-item v-for="(itemp, indexp) in item.wdpicslist" :key="indexp">
							<el-image :src="itemp.picurl" fit="fill" @click="goto(itemp.url)"  :class="itemp.link1!=''?'wd-cursor':''" class="carousel wd-img-percent-100"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-else-if="item.type == 6">
					<!--辅助空白-->
					<div class="wdline5 "></div>
				</div>
				<div v-else-if="item.type == 7">
					<!--分隔线-->
					<div class="wdline1"></div>
				</div>
				<div v-else-if="item.type == 8" class="wd-container"><!--商品列表-->
					<div class="goodslist5" :style="{background:item.fontbackgroundcolor}">
						<template v-for="(item2, index2) in item.wdgoodslist">
							<div class="goods" :key="index2" @click="gotogoodsdetail(item2.goodsid, item2.goodsname)">
								<div class="img"><el-image :src="$wdpicurl(item2.pic1)" fit="contain" class="img"></el-image></div>
								<div class="name">{{ item2.goodsname }}</div>
								<div class="price">¥{{ item2.retailprice }}</div>
							</div>
						</template>
					</div>
				</div>
				<div v-else-if="item.type == 9" class="wd-container">
					<!--图片-->
					<el-row class="" v-if="item.param<5">
						<el-col v-if="item.pic1!=''" :span="getspan(item.param)"><el-image @click="goto(item.link1)" class="wd-width-percent-100" :class="item.link1!=''?'wd-cursor':''" :src="$wdpicurl(item.pic1)" fit="fill" :lazy="true"></el-image></el-col>
						<el-col v-if="item.pic2!=''" :span="getspan(item.param)"><el-image @click="goto(item.link2)" class="wd-width-percent-100" :class="item.link2!=''?'wd-cursor':''" :src="$wdpicurl(item.pic2)" fit="fill" :lazy="true"></el-image></el-col>
						<el-col v-if="item.pic3!=''" :span="getspan(item.param)"><el-image @click="goto(item.link3)" class="wd-width-percent-100" :class="item.link3!=''?'wd-cursor':''" :src="$wdpicurl(item.pic3)" fit="fill" :lazy="true"></el-image></el-col>
						<el-col v-if="item.pic4!=''" :span="getspan(item.param)"><el-image @click="goto(item.link4)" class="wd-width-percent-100" :class="item.link4!=''?'wd-cursor':''" :src="$wdpicurl(item.pic4)" fit="fill" :lazy="true"></el-image></el-col>
					</el-row>
					<el-row v-else-if="item.param==5">
						<el-col :span="12">
							<div>
								<el-image @click="goto(item.link1)" :class="item.link1!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic1)" fit="fill" :lazy="true"></el-image>		
							</div>
							<div>
								<el-image @click="goto(item.link2)" :class="item.link2!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic2)" fit="fill" :lazy="true"></el-image>
							</div>
						</el-col>
						<el-col :span="12">
							<el-image @click="goto(item.link3)" :class="item.link3!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic3)" fit="fill" :lazy="true"></el-image>
						</el-col>
					</el-row>
					<el-row v-else-if="item.param==6">
						<el-col :span="12">
							<el-image @click="goto(item.link1)" :class="item.link1!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic1)" fit="fill" :lazy="true"></el-image>
						</el-col>
						<el-col :span="12">
							<div>
								<el-image @click="goto(item.link2)" :class="item.link2!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic2)" fit="fill" :lazy="true"></el-image>		
							</div>
							<div>
								<el-image @click="goto(item.link3)" :class="item.link3!=''?'wd-cursor':''" class="wd-width-percent-100" :src="$wdpicurl(item.pic3)" fit="fill" :lazy="true"></el-image>
							</div>
						</el-col>
					</el-row>
				</div>
				<div v-else-if="item.type == 11" class="wd-container"><!--搜索--></div>
				<div v-else-if="item.type == 12" class="wd-container"><!--文字-->
					<div 
					:style="{color:item.fontcolor,fontSize:item.fontsize+'px',textAlign:item.fontalign,fontWeight:item.fontweight,padding:item.fontpadding+'px',margin:item.fontmargin+'px',backgroundColor:item.fontbackgroundcolor}">
					{{item.memo}}
					</div>
				</div>
				<div v-else-if="item.type == 13" class="wd-container"><!--爆品--></div>
				<div v-else-if="item.type == 14" class="wd-container"><!--每日必抢--></div>
				<div class="classlist wd-container" ref="classlist"  v-else-if="item.type == 16"><!-- 商品分类 -->
					<div v-for="(item, index) in allclasslist" :key="index" class="floorright">
						<div class="wd-flex wd-row-between">
							<div class="title">{{ item.name }}</div>
							<div class="wd-flex wd-row-between wd-row-grow">
								<div><span class="wd-info">全部</span></div>
								<div class="wd-info">
									<router-link :to="{path:'/goodslist',query:{contype:3,classid:item.id,showname:item.name}}" tag="div">
										<span>更多</span>
										<i class="wd-m-l-5 wd-icon wd-font-12">&#xe606;</i>
									</router-link>
									
								</div>
							</div>
						</div>
						<div class="detail wd-flex wd-row-between">
							<div class="brand">
								<div class="n1"><el-image :src="$wdpicurl(item.adweb1)" class="img"></el-image></div>
								<div class="n2"><el-image :src="$wdpicurl(item.adweb2)" class="img"></el-image></div>
							</div>
							<div class="goodslist">
								<template v-for="(item2, index2) in item.detail">
									<div class="goods" :key="index2" @click="gotogoodsdetail(item2.goodsid, item2.goodsname)">
										<div class="img"><el-image :src="$wdpicurl(item2.pic1)" fit="contain" class="img"></el-image></div>
										<div class="name">{{ item2.goodsname }}</div>
										<div class="price">¥{{ item2.retailprice }}</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<!-- 导航楼层 -->
					<div class="daohang" :class="[showdaohang ? 'show' : '']">
						<div v-for="(item, index) in allclasslist" :key="index" class="row navleft" @click="setFloorNavMountClick(index)">
							<span>{{ index + 1 }}F</span>
							<span>{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Diy',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			code: '',
			wddatalist: [],
			wdpicslist: [],
			allclasslist: [],
			allclass_goods_list: [],
			allclasstop: 1200,
			showdaohang: false,
			seckilldatalist: [],
			seckillinfo: { id: 0 },
			allseconds: 0,
			showmoreclass:false
		};
	},
	methods: {
		getspan(param) {
			switch (param) {
				case '1':
					return 24;
				case '2':
					return 12;
				case '3':
					return 8;
				case '4':
					return 6;
				default:
					return 24;
			}
		},
		init() {
			this.getdiv();
			this.getindexclass();
			this.loadallclass();
		},
		loadseckillinfo() {
			var indata = {
				limit: 1,
				type: 0
			};

			this.$wd_request('seckilllist', indata)
				.then(data => {
					this.seckillinfo = data.value[0];
					if (this.seckillinfo.intdiffs < 0) {
						// this.diffTime(this.seckillinfo.intdiffs*-1,true);
						// this.diffTime(this.seckillinfo.intdiff);
						setTimeout(function() {
							this.allseconds_start = 0;
							this.startcountdown_s = false;
							// that.diffTime(that.seckillinfo.intdiff+that.seckillinfo.intdiffs);
						}, this.seckillinfo.intdiffs * -1000);
					} else {
						this.diffTime(this.seckillinfo.intdiff);
					}
					this.loadseckillgoodslist();
				})
				.catch(() => {});
		},
		loadseckillgoodslist() {
			var indata = {
				limit: 5,
				seckillid: this.seckillinfo.id
			};

			this.$wd_request('seckill_goodslist', indata)
				.then(data => {
					this.seckilldatalist = data.value;
				})
				.catch(() => {});
		},
		gotoseckill() {
			// uni.navigateTo({
			// 	url:"../zt/seckill/seckill?seckillid="+this.seckillinfo.id
			// })
		},
		loadsuggestlist() {
			var indata = {
				contype: 5,
				limit: 2
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					this.suggestdatalist = data.value;
				})
				.catch(() => {});
		},
		loadtradetypelist() {
			var indata = {
				contype: 5,
				limit: 2,
				con: '海外直邮'
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					this.tradetypedatalist = data.value;
				})
				.catch(() => {});
		},
		goto(module){
			console.log(module);
			let code = module.substr(0, 4);
			if (module == "main") {
				this.$router.push("/");
			} else if (module == "my") {
				this.$router.push("/member");
			} else if (module == "search") {
				this.$router.push("/goodslist");
			} else if (module == "cart") {
				this.$router.push("/cart");
			} else if (code == "code") {
				this.$router.push({path:"/Diy",query:{code:code}});
			} else if (code == "con=") {
				this.$router.push({path:"/goodslist"});
			} else if (code == "good") {
				this.$router.push({path:"/goodsinfo",query:{goodsid:module.substr(8,module.length-8)}});
			} else {
				this.$router.push(module);
			}
		},
		getdiv() {
			let indata = {
				code: this.code
			};
			this.$wd_request('getdiy', indata)
				.then(data => {
					this.wddatalist = data.value;
					this.getgoodslist();
					this.getpiclist();
				})
				.catch(() => {});
		},
		getindexclass() {
			let indata = {
				type: 'class'
			};
			this.$wd_request('getindex', indata)
				.then(data => {
					this.wdclasslist = data.value;
				})
				.catch(() => {});
		},
		getindexpics(index) {
			var item = this.wddatalist[index];
			let indata = {
				type: item.pictype,
			};

			this.$wd_request('getindex', indata)
				.then(data => {
					item.wdpicslist = data.value;
					this.$set(this.wddatalist, index, item);
				})
				.catch(() => {});
		},
		getpiclist() {
			for (var i = 0; i < this.wddatalist.length; i++) {
				let ii = i;
				let item = this.wddatalist[i];
				if (item.type == '2') {
					this.getindexpics(ii);
				}
			}
		},
		getgoods(item) {
			let indata = {
				con: '',
				classid: 0,
				contype: 9,
				detailid: item.id,
				branchid: this.branchid
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					item.wdgoodslist = data.value;
				})
				.catch(() => {});
		},
		getgoodslist() {
			for (var i = 0; i < this.wddatalist.length; i++) {
				var item = this.wddatalist[i];
				if (item.type == '8') {
					this.getgoods(item);
				}
			}
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				path: '/goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		loadallclass() {
			this.$wd_request('appgoodsclass_main')
				.then(data => {
					if (data.rs == 0) {
						this.allclasslist = data.value;
						for (var i = 0; i < this.allclasslist.length; i++) {
							this.findallclassgoods(i, this.allclasslist[i].id);
						}
					}
				})
				.catch(() => {});
		},
		findallclassgoods(index, classid) {
			let indata = {
				cnt: -1,
				page: 1,
				contype: 8,
				con: '',
				classid: classid,
				limit: 8
			};
			this.$wd_request('goodslist', indata)
				.then(data => {
					var item = this.allclasslist[index];
					item.detail = data.value;
					this.$set(this.allclasslist, index, item);
				})
				.catch(() => {});
		},
		loadcarousellist() {
			this.$wd_request('getindex', { type: 'webindex' }).then(data => {
				this.carousellist = data.value;
			});
		},
		/**
		 * 监听窗口滚动楼层导航动态定位
		 */
		floorSrcollEventListener() {
			// var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// if (scrollTop > this.allclasstop) {
			// 	this.showdaohang = true;
			// } else {
			// 	this.showdaohang = false;
			// }
			this.showdaohang = false;
			const { nav_item, floor_item } = this.element;
			const window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			for (let i = 0, len = floor_item.length; i < len; i++) {
				let floor_offsetTop = floor_item[i].offsetTop-600 ;//- floor_item[0].offsetTop;
				if (window_scrollTop >= floor_offsetTop) {
					this.showdaohang = true;
					for (let n = 0, len = nav_item.length; n < len; n++) {
						const current_classList = nav_item[n].classList;
						i === n ? current_classList.add('active') : current_classList.remove('active');
					}
				}
			}
		},
		/**
		 * 设置楼层导航事件驱动方法
		 * @param {Number} index  楼层下标
		 */
		setFloorNavMountClick(index) {
			const { floor_item } = this.element;
			const floor_offsetTop = floor_item[index].offsetTop-300,// - floor_item[0].offsetTop,
				window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop,
				timer = {
					step: 300,
					times: 16,
					FLOOR_OFFSETTOP: floor_offsetTop
				};
			if (window_scrollTop > floor_offsetTop) {
				this.setFloorScrollArrowUp(timer);
			} else if (window_scrollTop == floor_offsetTop) {
				return false;
			} else {
				this.setFloorScrollArrowDown(timer);
			}
		},
		/**
		 * 设置楼层向上滚动
		 * @param {Object} timer 定时器配置
		 */
		setFloorScrollArrowUp(timer) {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (window_scrollTop <= timer.FLOOR_OFFSETTOP) {
					document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP;
					document.body.scrollTop = timer.FLOOR_OFFSETTOP;
					clearInterval(this.timer);
				} else {
					document.documentElement.scrollTop = window_scrollTop - timer.step;
					document.body.scrollTop = window_scrollTop - timer.step;
				}
			}, timer.times);
		},
		/**
		 * 设置楼层向下滚动
		 * @param {Object} timer 定时器配置
		 */
		setFloorScrollArrowDown(timer) {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (window_scrollTop >= timer.FLOOR_OFFSETTOP) {
					document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP;
					document.body.scrollTop = timer.FLOOR_OFFSETTOP;
					clearInterval(this.timer);
				} else {
					document.documentElement.scrollTop = window_scrollTop + timer.step;
					document.body.scrollTop = window_scrollTop - timer.step;
				}
			}, timer.times);
		}
	},
	created() {
		// this.init();
	},
	activated() {
		let aflag=this.$route.params.code||"";
		if (aflag==""){
			aflag=this.$route.query.code||"";
		}
		if (aflag!=="" && aflag!==this.code){
			this.code=aflag;
			this.init();
			if (this.code==="webindex"){
				this.showmoreclass=true;
			}
		}
	},
	mounted() {
		this.$nextTick(function(){
			this.element = {
				nav_item: document.getElementsByClassName('navleft'),
				floor_item: document.getElementsByClassName('floorright')
			};
			window.addEventListener('scroll', this.floorSrcollEventListener,true);
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.floorSrcollEventListener,true);
	}
};
</script>

<style lang="scss" scoped>
::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
	white-space: nowrap;
}

.home {
	.calousel {
		width: 100%;
		height: 100%;
	}
	.ad1list {
		margin-top: 30px;
		.img {
			border-radius: 5px;
			.img2 {
				background-color: #ffffff;
				border-radius: 5px;
			}
		}
	}
	.hot {
		.title {
			width: 240px;
			height: 36px;
			font-weight: 500;
			font-size: 26px;
			color: #333;
			font-weight: bold;
			border-left: 6px solid #ff4c4c;
			padding-left: 10px;
			line-height: 36px;
			margin: 30px 0 15px;
		}
		.detail {
			height: 300px;
			width: 100%;
			.goods {
				width: 300px;
				height: 300px;
				display: inline-block;
				padding: 0 10px;
				.img {
					width: 250px;
					height: 250px;
				}
				&:hover {
					cursor: pointer;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
	}
	.classlist {
		.title {
			width: 240px;
			height: 36px;
			font-weight: 500;
			font-size: 26px;
			color: #333;
			font-weight: bold;
			border-left: 6px solid #ff4c4c;
			padding-left: 10px;
			line-height: 36px;
			margin: 30px 0 15px;
		}
		.wd-info{
			cursor: pointer;
		}
		.brand {
			width: 240px;
			min-height: 1px;
			height: 588px;
			.n1 {
				display: block;
				width: 240px;
				height: 436px;
				overflow: hidden;
				margin-bottom: 14px;
				.img {
					display: block;
					width: 240px;
					height: 436px;
					object-fit: cover;
					border-radius: 5px;
				}
			}
			.n2 {
				display: block;
				width: 240px;
				height: 124px;
				overflow: hidden;
				.img {
					display: block;
					width: 240px;
					height: 124px;
					border-radius: 5px;
					object-fit: cover;
				}
			}
		}
		.detail {
			height: 588px;
			.goods {
				float: left;
				width: 226px;
				height: 280px;
				background-color: #fff;
				overflow: hidden;
				text-align: center;
				margin-left: 14px;
				border-radius: 5px;
				margin-bottom: 14px;
				transition: 0.5s;
				.img {
					width: 160px;
					height: 160px;
					margin: 10px auto 0;
					overflow: hidden;
				}
				.name {
					font-size: 14px;
					width: 200px;
					height: 40px;
					line-height: 20px;
					color: #666;
					margin: 20px auto 0;
					overflow: hidden;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
				.price {
					font-size: 14px;
					width: 200px;
					height: 40px;
					line-height: 40px;
					color: #ff4c4c;
					margin: 0px auto 0;
				}
				&:hover {
					cursor: pointer;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
	}
	.daohang {
		background-color: #ffffff;
		position: fixed;
		top: 30%;
		margin-left: -100px;
		z-index: 20;
		border: 1px solid #ddd;
		display: none;
		&.show {
			display: block;
		}
		.row {
			width: 50px;
			height: 30px;
			padding: 5px;
			line-height: 15px;
			font-size: 12px;
			color: #999;
			text-align: center;
			overflow: hidden;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			&:nth-last-child(1) {
				border-bottom: 0;
			}
			&.active {
				color: #ffffff;
				background-color: #aaa;
			}
			span {
				display: block;
				height: 15px;
				width: 50px;
				overflow: hidden;
			}
		}
	}
}
::v-deep .el-carousel__container {
	height: 480px !important;
}
.goodslist5{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		.goods {
			width: 226px;
			height: 280px;
			background-color: #fff;
			overflow: hidden;
			text-align: center;
			margin-left: 14px;
			border-radius: 5px;
			margin-bottom: 14px;
			transition: 0.5s;
			.img {
				width: 160px;
				height: 160px;
				margin: 10px auto 0;
				overflow: hidden;
			}
			.name {
				font-size: 14px;
				width: 200px;
				height: 40px;
				line-height: 20px;
				color: #666;
				margin: 20px auto 0;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
			}
			.price {
				font-size: 14px;
				width: 200px;
				height: 40px;
				line-height: 40px;
				color: #ff4c4c;
				margin: 0px auto 0;
			}
			&:hover {
				cursor: pointer;
				box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
				//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
			}
		}
	}
</style>
